import { delay } from "redux-saga";
import { put, call, select, takeEvery, takeLatest } from "redux-saga/effects";
import {
  generateQueryString,
  parseQueryString
} from "../../modules/common/utils";
import * as action from "./actions";
import * as api from "../../apis";
import * as merchant_action from "../Merchant/actions";
import * as analytics_action from "../Analytics/actions";
import moment from "moment";

export function* getStoreVisitsPublications(request: IPayload) {
  try {
    yield put(analytics_action.setPublicationsLoading(true));
    let response = yield call(
      api.fetchStoreVisitsPublications,
      request.payload
    );
    yield put(analytics_action.addPublications(response));
    yield put(analytics_action.setPublicationsLoading(false));
  } catch (e) {
    console.log(e);
    yield put(analytics_action.setPublicationsLoading(false));
    yield put(action.getPublicationsFailure());
  }
}

export function* watchGetStoreVisitsPublications() {
  yield takeEvery(action.GET_PUBLICATIONS, getStoreVisitsPublications);
}

export function* getStoreVisitsMerchants(request: IPayload) {
  try {
    let response = yield call(api.fetchStoreVisitsMerchants, request.payload);
    yield put(merchant_action.addMerchants(response));
  } catch (e) {
    yield put(action.getMerchantsFailure());
  }
}

export function* watchGetStoreVisitsMerchants() {
  yield takeEvery(action.GET_MERCHANTS, getStoreVisitsMerchants);
}

export function* syncQueryString(request: IPayload) {
  let queryObj = parseQueryString(request.payload.queryString);
  let qString = generateQueryString(queryObj);

  if (!moment(queryObj.start_date, "YYYY-MM-DD").isValid()) {
    delete queryObj.start_date;
  }
  if (!moment(queryObj.end_date, "YYYY-MM-DD").isValid()) {
    delete queryObj.end_date;
  }
  if (queryObj.flyer_run_ids) {
    let flyer_run_ids: any[] = queryObj.flyer_run_ids;
    queryObj = {
      ...queryObj,
      flyer_run_ids: flyer_run_ids.filter((item) => typeof item != "number")
    };
  }
  if (typeof parseInt(queryObj.merchant) != "number") {
    delete queryObj.merchant;
  }

  yield put(action.setEndDate(queryObj.end_date));
  yield put(action.setStartDate(queryObj.start_date));
  yield put(action.setPublicationSelection(queryObj.flyer_run_ids));
  yield put(action.setMerchantSelection(queryObj.merchant));
  //not too sure what the use case is for storing a sanitized query string on state tree
  yield put(action.setQueryString(generateQueryString(queryObj)));
}

export function* watchSynchronizeQueryString() {
  yield takeLatest(action.SYNC_QUERY_STRING, syncQueryString);
}

export function* getTopStoresData(request: IPayload) {
  try {
    const { start_date, end_date, flyer_run_ids } = request.payload;
    yield put(action.clearTopStoresData());
    if (start_date && end_date && flyer_run_ids) {
      //only make requests when all parameters are present
      yield call(delay, 500);
      let response = yield call(
        api.fetchStoreVisitsTopStoresData,
        request.payload
      );
      yield put(action.setTopStoresData(response));
    }
  } catch (e) {
    console.error(e);
    yield put(action.getTopStoresDataFailure());
  }
}

export function* watchGetTopStoresData() {
  yield takeLatest(action.GET_TOP_STORES_DATA, getTopStoresData);
}



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/sagas.ts